import React from 'react'
import Prism from 'prismjs'
import Raven from 'raven-js'
import { format } from 'sql-formatter'
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace'
import 'prismjs/plugins/toolbar/prism-toolbar'
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-ini'
import 'prismjs/components/prism-apacheconf'
import 'prismjs/components/prism-nginx'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-sql'

interface Props {
    code: string
    language?: 'bash' | 'php' | 'css' | 'ini' | 'apacheconf' | 'nginx' | 'javascript' | 'yaml' | 'sql'
}

export const formatSql = (code: string): string => {
    let query = code.replace(/\[\.\.\]/g, '/* placeholder */')

    try {
        query = format(query, { language: 'mysql' })
    } catch (error) {
        // Fail silently and keep SQL unformatted.
        Raven.captureException(error)
    }

    return query.replace(/\/\* placeholder \*\//g, '[..]')
}

export class CodeBlock extends React.PureComponent<Props> {
    componentDidMount() {
        Prism.highlightAll()
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
        Prism.highlightAll()
    }

    // Cautious: the wrapping <div/> is required, since PrismJs not only replaces the <code/> element, but also
    // the <pre/> element. Therefore, when unmounting, React can crash trying to find the <pre/> element. see GH-9428
    render = () => {
        const code = this.props.language === 'sql' ? formatSql(this.props.code) : this.props.code

        return (
            <div>
                <pre>{this.props.language ? <code className={`language-${this.props.language}`}>{code}</code> : <code>{code}</code>}</pre>
            </div>
        )
    }
}
